import Profile from "../components/Dash/Test/Listing/employeeProfile";
import Nav from "../components/Nav/nav";
import Whatsapp from "../Whatsapp/whatsapp";

const ProfPage = () => {
  return (
    <div>
      <Nav />
      <Profile />
      <Whatsapp/>
    </div>
  );
};

export default ProfPage;
